(function ($) {


    // ARTICLE CARD SLIDER

    $('.article-card-slider').slick({
        slidesToShow: 3,
        dots: false,
        infinite: false,
        arrows: false,
        touchMove: false,
        swipe: false,
        responsive: [
            {
                breakpoint: 950,
                settings: {
                    swipe: true,
                    touchMove: true,
                    slidesToShow: 2,
                    infinite: false,
                    draggable: true,

                }
            },
            {
                breakpoint: 700,
                settings: {
                    swipe: true,
                    touchMove: true,
                    slidesToShow: 1.7,
                    centerMode: false,
                    infinite: false,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    swipe: true,
                    touchMove: true,
                    slidesToShow: 1.3,
                    centerMode: false,
                    infinite: false,
                }
            },
            {
                breakpoint: 500,
                settings: {
                    swipe: true,
                    touchMove: true,
                    slidesToShow: 1.2,
                    infinite: false,
                    centerMode: false
                }
            },
            {
                breakpoint: 400,
                settings: {
                    swipe: true,
                    touchMove: true,
                    slidesToShow: 1.1,
                    infinite: false,
                    centerMode: false
                }
            }
        ]
    });

    // let articleCardSlider = $('.article-card-slider')
    // settings = {
    //     slidesToShow: 3,
    //     dots: false,
    //     infinite: false,
    //     arrows: false,
    //     responsive: [
    //         {
    //             breakpoint: 950,
    //             settings: {
    //                 slidesToShow: 2,
    //                 infinite: false,
    //                 draggable: true,
    //
    //             }
    //         },
    //         {
    //             breakpoint: 700,
    //             settings: {
    //                 slidesToShow: 1.7,
    //                 centerMode: false,
    //                 infinite: false,
    //             }
    //         },
    //         {
    //             breakpoint: 600,
    //             settings: {
    //                 slidesToShow: 1.3,
    //                 centerMode: false,
    //                 infinite: false,
    //             }
    //         },
    //         {
    //             breakpoint: 500,
    //             settings: {
    //                 slidesToShow: 1.2,
    //                 infinite: false,
    //                 centerMode: false
    //             }
    //         },
    //         {
    //             breakpoint: 400,
    //             settings: {
    //                 slidesToShow: 1.1,
    //                 infinite: false,
    //                 centerMode: false
    //             }
    //         }
    //     ]
    // }
    //
    // $(window).on('load resize', function() {
    //     if ($(window).width() > 950) {
    //         if (articleCardSlider.hasClass('slick-initialized')) {
    //             articleCardSlider.slick('unslick');
    //         }
    //     } else {
    //         articleCardSlider.slick(settings);
    //     }
    // });

    var sectionHero = $('.section-hero.image-full-size');


    // SCROLL DOWN TO NEXT SECTION

    $('.scroll-down-btn').on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $('.section-hero').offset().top + (sectionHero.outerHeight())
        }, 500)
    });


    // FOOTNOTE POSITION FIX
    $('.footnote_plugin_tooltip_text')
        .bind('mouseover', function() {
            var id = $(this).attr("id");
            checkTooltipPosition(id);  
        });

    function checkTooltipPosition(id){
        var text_id = id.replace("footnote_plugin_tooltip", "footnote_plugin_tooltip_text");
        var text_elem = $("#"+text_id);
        var left = parseFloat(text_elem.css("left"));
        // alert(left);
        if (left<10){
            text_elem.css("left", 10+"px");
        }
    }


    //FOOTNOTE DUPLICATES FIX
    function getRidOdFootnoteDuplicates(){
        var haveMadeChanges = false;
        var len = $('.footnote_plugin_index_combi').length;
        for (var i=0; i<len; i++){
            var combi = $('.footnote_plugin_index_combi').eq(i);
            var backlinks = combi.find(".footnote_backlink");
            var len2 = backlinks.length;
            if (backlinks.length>1){
                var first_backlink = backlinks.eq(0);
                var first_link_id = first_backlink.attr("id");
                var first_text_id = first_link_id.replace("footnote_plugin_reference", "footnote_plugin_tooltip_text");
                var first_referer = $("#"+first_text_id).closest(".footnote_referrer");
                var first_a_link = first_referer.find(".footnote_plugin_tooltip_text").closest("a");

                for (var j=0; j<len2; j++){
                    if (j>0){
                        var link = backlinks.eq(j);
                        var link_id = link.attr("id");
                        var text_id = link_id.replace("footnote_plugin_reference", "footnote_plugin_tooltip_text");
                        var referer = $("#"+text_id).closest(".footnote_referrer");
                        var a_link = referer.find(".footnote_plugin_tooltip_text").closest("a");
                        referer.find(".footnote_plugin_tooltip_text").html(first_referer.find(".footnote_plugin_tooltip_text").html());
                        a_link.attr("onclick", first_a_link.attr("onclick"));
                        // footnote_plugin_reference_108_1_3
                        // footnote_plugin_tooltip_text_108_1_3

                        backlinks.eq(j).remove();
                        haveMadeChanges = true;
                    }
                }
            }
        }
        if(haveMadeChanges){
            fixFootnoteNumeration();
        }
    }
    function fixFootnoteNumeration(){
        var len = $('.footnote_plugin_index_combi .footnote_backlink').length;
        for (var i=0; i<len; i++){
            var backlink = $('.footnote_plugin_index_combi .footnote_backlink').eq(i);
            
            var bl_html = backlink.html();
            bl_html = '<span class="footnote_index_arrow">↑</span>'+(i+1);
            backlink.html(bl_html);
            // <span class="footnote_index_arrow">↑</span>
            // alert();
            // var link = backlinks.eq(j);
            var link_id = backlink.attr("id");
            var text_id = link_id.replace("footnote_plugin_reference", "footnote_plugin_tooltip_text");
            var referer = $("#"+text_id).closest(".footnote_referrer");
            referer.find(".footnote_plugin_tooltip_text").html("["+(i+1)+"]");
            // // footnote_plugin_reference_108_1_3
            // // footnote_plugin_tooltip_text_108_1_3

            // backlinks.eq(j).remove();
                   
        }
    }
    getRidOdFootnoteDuplicates();


    // STICKY HEADER FUNCTION
    function initStickyHeader(){
        var last_scroll = 0;
        var treshold_show = 0;
        var treshold_hide = 0;
        var header = $("header");
        var lock = false;
        var header_height = header.outerHeight();
        $(window).resize(function(){
            header_height = header.outerHeight();
        })
        $(window)[0].addEventListener("scroll", function(e){
            var scroll_top = $(window).scrollTop();
            if (scroll_top>header_height){
                if (!lock){
                    if (scroll_top<last_scroll){
                        treshold_show++;
                        treshold_hide = 0;
                        if (treshold_show>10){
                            if (!header.hasClass("fixed")){
                                // alert("a");
                                showFixed();
                            }
                        }
                    }else{
                        treshold_show = 0;
                        treshold_hide++;
                        if (treshold_hide>10){
                            if (header.hasClass("fixed")){
                                hideFixed();
                            }
                        }
                    }
                    last_scroll = scroll_top;
                }
            }else{
                if (scroll_top<=0){
                    treshold_show = 0;
                    treshold_hide = 0;
                    if (header.hasClass("fixed")){
                        header.removeClass("fixed");
                    }
                }
            }
        });

        function showFixed(){
            lock = true;
            treshold_show = 0;
            treshold_hide = 0;
            header.addClass("fixed");
            TweenLite.to(header, 0, {ease:Power1.easeIn, y:-header_height,  delay: 0, onComplete: function(){ }});
            TweenLite.to(header, 0.3, {ease:Quad.easeOut, y:0,  delay: 0, onComplete: function(){
                lock = false;
            }});
        }
        function hideFixed(){
            lock = true;
            treshold_show = 0;
            treshold_hide = 0;
            TweenLite.to(header, 0, {ease:Power1.easeIn, y:0,  delay: 0, onComplete: function(){ }});
            TweenLite.to(header, 0.3, {ease:Quad.easeIn, y:-header_height,  delay: 0, onComplete: function(){
                TweenLite.to(header, 0, {ease:Power1.easeIn, y:0,  delay: 0, onComplete: function(){ }});
                header.removeClass("fixed");
                lock = false;
            }});
        }
        
    }

    initStickyHeader();


})(jQuery);